module.exports = __webpack_public_path__ + "img/404-mob-uk.97e0460.svg";